import ConnectorViewMappingPrint from '../../../../antd/connector_views/connector_mapping/print'

const ConnectorViewMappingsPrintPage = () => {
  return <ConnectorViewMappingPrint />
}

export default ConnectorViewMappingsPrintPage
